/* Standard offer buy box (sections/hl-bundle.liquid). One source of truth for the picks
   (picks[]); every "Your mix" line on the page and the desktop bottom bar read from it, and the lower
   buttons only scroll back to the picker, so nothing resets a choice.
   Add to cart: the picks name one variant of the native bundle product (one option per pick,
   e.g. Tube 1, Tube 2, Tube 3). That variant goes into the cart through the Cart API, once: the
   button is locked while the request runs. A choice whose mix has no available variant is disabled, and a picked mix that
   is not available stops the button with a message; nothing is swapped without the buyer.
   The form has no /cart/add action: Monster Upsell takes over any such form. After the add,
   monster_refresh() re-reads the cart and opens its drawer; with no drawer the buyer goes to the
   cart page. Events match listicle-bundle.js (pf_add_to_cart_success, pf_add_to_cart_error), sent
   only with analytics consent; Shopify reports the cart add itself.
   Not named hl-*: build.py deletes every hl-* asset that is not a staged image. */
(() => {
  'use strict';
  if (window.HLR499) return;
  window.HLR499 = true;
  function init(root) {
    const $ = selector => root.querySelector(selector);
    const form = $('[data-hl-r499-form]');
    if (!form) return;
    const variants = JSON.parse($('[data-hl-r499-variants]')?.textContent || '[]');
    const ready = root.dataset.ready === 'true' && variants.length > 0;
    const preview = root.dataset.preview === 'true';
    const name = root.dataset.name || 'Your bundle';
    const slot = root.dataset.slot || 'tube';
    const sets = [...form.querySelectorAll('[data-tube]')];
    const add = $('[data-add]');
    const label = $('[data-add-label]');
    const idle = label.textContent;
    const error = $('[data-error]');
    const message = $('[data-message]');
    const sticky = $('[data-hl-r499-sticky]');
    const picks = sets.map(set => (set.querySelector('input:checked') || set.querySelector('input')).value);
    let busy = false;
    let cartError = false;
    const find = list => variants.find(v => v.options.length >= list.length && list.every((o, i) => v.options[i] === o));
    // Start on an available mix when the default one is sold out.
    if (ready && !find(picks)?.available) {
      const open = variants.find(v => v.available);
      if (open) picks.forEach((_, i) => { picks[i] = open.options[i]; });
    }
    const mix = () => picks.join(', ');
    function render() {
      sets.forEach((set, i) => {
        set.querySelectorAll('input').forEach(input => {
          input.checked = input.value === picks[i];
          // A flavour stays open while any available mix uses it in this tube, so a sold-out
          // pick never locks the buyer in; locked while the cart request runs.
          if (ready) input.disabled = busy || (!variants.some(v => v.available && v.options[i] === input.value) && input.value !== picks[i]);
          else input.disabled = busy;
        });
        set.querySelector('[data-tube-value]').textContent = picks[i];
      });
      document.querySelectorAll('[data-hl-r499-mix]').forEach(node => { node.textContent = mix(); });
      const v = ready ? find(picks) : null;
      const ok = !ready || Boolean(v && v.available);
      if (!ok) {
        error.textContent = !picks.length ? `${name} is sold out right now.`
          : v ? `This mix is sold out right now. Choose another flavour for one of your ${slot}s.` : `This mix is not available. Choose another flavour for one of your ${slot}s.`;
        error.hidden = false;
      } else if (!cartError) {
        error.hidden = true;
      }
      label.textContent = busy ? 'Adding…' : ok ? idle : 'Mix sold out';
      add.disabled = busy || !ok;
      form.setAttribute('aria-busy', String(busy));
    }
    function emit(event, extra = {}) {
      const v = ready ? find(picks) : null;
      const detail = {product_id: root.dataset.productId, variant_id: v ? v.id : null, flavours: picks.slice(), value: v ? v.price / 100 : null, ...extra};
      root.dispatchEvent(new CustomEvent(event, {bubbles: true, detail}));
      if (!preview && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event, ...detail});
      }
    }
    function say(text) {
      $('[data-message-text]').textContent = text;
      message.hidden = false;
    }
    // A page on this store, as a string: an app on the store wraps fetch and fails on URL objects.
    function here(path, base = '/') {
      const url = new URL(path, new URL(base, location.origin));
      if (url.origin !== location.origin) throw new Error('Cart must be on this store.');
      return url.href;
    }
    async function call(path, body, signal) {
      const options = body
        ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body), signal}
        : {headers: {Accept: 'application/json'}, signal};
      const response = await fetch(here(path, root.dataset.cartRoot || '/'), options);
      let result;
      try { result = await response.json(); } catch { throw new Error('The store returned an unexpected response. Check your cart before trying again.'); }
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : `${name} could not be added. Please try again.`);
      return result;
    }
    function drawerOpen() {
      const drawer = document.getElementById('monster-cart-wrapper');
      if (!drawer) return false;
      const box = drawer.getBoundingClientRect();
      return drawer.classList.contains('mu_openned') || (box.width > 0 && box.left < innerWidth - 1 && box.right > 0);
    }
    function cartIfNoDrawer() {
      const cartPage = here(root.dataset.cartUrl || '/cart');
      if (typeof window.monster_refresh !== 'function') { location.assign(cartPage); return; }
      const started = Date.now();
      (function check() {
        if (drawerOpen()) return;
        if (Date.now() - started < 6000) setTimeout(check, 250); else location.assign(cartPage);
      })();
      try { window.monster_refresh(); } catch { /* the watch above sends the buyer to the cart */ }
    }
    form.addEventListener('change', event => {
      const set = event.target.closest('[data-tube]');
      if (!set) return;
      picks[Number(set.dataset.tube)] = event.target.value;
      cartError = false;
      message.hidden = true;
      render();
      emit('pf_variant_change');
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      if (!ready) {
        say(`Preview only: this offer is not on sale yet.${picks.length ? ` Your mix: ${mix()}.` : ''}`);
        return;
      }
      const v = find(picks);
      if (!v || !v.available) { render(); return; }
      if (preview) {
        say(`Preview only: checkout is inactive here.${picks.length ? ` Your mix: ${mix()}.` : ''}`);
        return;
      }
      busy = true;
      cartError = false;
      message.hidden = true;
      render();
      const sent = mix();
      const request = new AbortController();
      const timeout = setTimeout(() => request.abort(), 20000);
      try {
        const result = await call('cart/add.js', {items: [{id: v.id, quantity: 1}]}, request.signal);
        emit('pf_add_to_cart_success', {quantity: 1});
        document.dispatchEvent(new CustomEvent('pf:cart-added', {detail: {items: result.items || [result]}}));
        say(`Added to your cart: ${name}${sent ? `, ${sent}` : ''}.`);
        cartIfNoDrawer();
      } catch (problem) {
        cartError = true;
        error.textContent = problem.name === 'AbortError' ? 'The request took too long. Check your cart before trying again.'
          : problem.name === 'TypeError' ? "We couldn't confirm the addition. Check your cart before trying again." : problem.message;
        error.hidden = false;
        emit('pf_add_to_cart_error');
      } finally {
        clearTimeout(timeout);
        busy = false;
        render();
      }
    });
    $('[data-dismiss]').addEventListener('click', () => { message.hidden = true; });
    // Every "back to the picker" control on the page: scroll, then focus the first pick.
    const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
    document.querySelectorAll('[data-hl-r499-choose], a[href="#choose"]').forEach(control => {
      control.addEventListener('click', event => {
        event.preventDefault();
        $('#choose').scrollIntoView({behavior: smooth()});
        sets[0]?.querySelector('input:checked')?.focus({preventScroll: true});
      });
    });
    // The bottom bar shows while no part of the picker is on screen, and not over the closing
    // summary, which has its own button. CSS keeps it off phones.
    const summary = document.getElementById('bundle-summary');
    const onScreen = node => { const box = node.getBoundingClientRect(); return box.top < innerHeight && box.bottom > 58; };
    let scheduled = false;
    function place() {
      scheduled = false;
      sticky.hidden = onScreen(form) || Boolean(summary && onScreen(summary));
    }
    const queue = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(place); } };
    addEventListener('scroll', queue, {passive: true});
    addEventListener('resize', queue);
    render();
    place();
  }
  // Offer countdown (operator 2026-10-20): each visitor's clock starts on the first visit and runs
  // down from data-hours; at zero it starts again. The start time is kept in localStorage, so a
  // revisit carries on where it was. Without storage, the clock runs on fixed cycles from midnight
  // UTC, so a reload still does not reset it.
  // The strip sits in the top bar (hl-topbar.liquid). It scrolls away while the logo row sticks,
  // as the yellow line did: --hl-strip-h lifts the sticky bar by the strip's height.
  function countdown() {
    const bar = document.querySelector('[data-hl-r499-timer]');
    const strip = document.querySelector('[data-hl-top-strip]');
    if (strip) {
      const lift = () => document.documentElement.style.setProperty('--hl-strip-h', `${strip.offsetHeight}px`);
      lift();
      addEventListener('resize', lift);
    }
    if (!bar) return;
    const clock = bar.querySelector('[data-hl-r499-clock]');
    const span = (Number(bar.dataset.hours) || 12) * 3600000;
    let start = 0;
    try {
      start = Number(localStorage.getItem('hl-r499-timer')) || 0;
      if (!start || start > Date.now()) { start = Date.now(); localStorage.setItem('hl-r499-timer', String(start)); }
    } catch { start = 0; }
    const two = n => String(n).padStart(2, '0');
    function tick() {
      const left = span - ((Date.now() - start) % span);
      const s = Math.floor(left / 1000);
      clock.textContent = `${two(Math.floor(s / 3600))}:${two(Math.floor(s / 60) % 60)}:${two(s % 60)}`;
    }
    tick();
    setInterval(tick, 1000);
  }
  function mount() { document.querySelectorAll('[data-hl-r499]').forEach(init); countdown(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true}); else mount();
})();
